/**
 * 积分管理
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 */
import React from 'react';
import {  Popover,message, Spin } from "antd";
import AuthBtn from "@components/HoverIcon/AuthBtn";
import Lang from "@/components/Lang/Lang";
import ModalFormComponent from '@components/ModalForm/ModalForm';
import {getCustomer,getPointItem,savePointSubmit} from "../../../api/customer";
class UserScore extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            // 积分管理
            showUserScoreModal: false,
            fromInitialValues:{},
            countryList:[], //国家信息
            optionsVipScorePop:[
                {
                    name:'pointAmountText',
                    cnTitle:'积分兑换',
                    cnTitleId:'JiFenDuiHuan',
                    type:'Text',
                },
                {
                    name:'point',
                    cnTitle:'当前积分',
                    cnTitleId:'DangQianJiFen',
                    type:'Text',
                },
            ],
            countryOptions:[],
            moreOptions:[
            ],
            editType: '', //加减操作类型
            enumAddList:[
            ],
            enumList:[
            ]
        }
    }
    changeEnum(value,option){
        const {enumAddList,enumList,fromInitialValues,editType} = this.state;
        const list = editType=='1'? enumAddList: enumList;
        const curr = list.find(item=>item.code==value)||{};
        if(value=="140"){//自定义的交互
            fromInitialValues["selectPoint"] ="";
            fromInitialValues["pointRuleConfigId"] = option.id;
            this.setMoreForm(editType,list,fromInitialValues,"Number",true);
        }else {
            // 赋值 selectPoint
            fromInitialValues["selectPoint"] = curr.point;
            fromInitialValues["pointRuleConfigId"] = option.id;
            // this.setState({
            //     fromInitialValues:fromInitialValues
            // })
            this.setMoreForm(editType,list,fromInitialValues,);
        }
    }
    // 修改积分账号
    changePoint(countryCode=""){
        const {countryList,} = this.state;
        const current = countryList.find(item=>item.countryCode==countryCode)||{}
        this.setFormData(current,countryList) // 设置表单内容
    }
    changeType(type){
        const {editType,enumList,enumAddList,fromInitialValues} = this.state;
        const {row} = this.props;
        if(type&&type!=editType){
            if(this.onRefFormFormat){
                this.onRefFormFormat.setField('pointRuleConfigCode');// 重置 积分项
                this.onRefFormFormat.setField('selectPointValue');// 重置 积分项
                this.onRefFormFormat.setField('remark');// 重置积分
            }
            fromInitialValues["selectPoint"] = ""; //  	说明
            if((type=="1"&&enumAddList.length>0)||(type=="-1"&&enumList.length>0)){ // 增加 || 扣减 有数据时 直接修改数据
                this.setMoreForm(type,type=="-1"?enumList:enumAddList,fromInitialValues);
            }else { //获取字典
                this.loading(true);
                getPointItem({
                    type: Number(type),
                    buyerId: row.id,
                    countryCode: fromInitialValues.countryCode
                }).then((res={})=>{
                    const data = res.data;
                    this.loading(false);
                    if(data.success&&data.valid){
                        const list = data.models;
                        this.setMoreForm(type,list,fromInitialValues);
                        if(type==1){ // 增加
                            this.setState({
                                enumAddList:list
                            })
                        }else { // 扣减
                            this.setState({
                                enumList:list
                            })
                        }
                    }
                })

            }

        }
    }
    setMoreForm(type,enumList=[],fromInitialValues={},selectPointType="Text",needRemark = false){
        let list = [
            {
                name:'pointRuleConfigCode',
                cnTitle:'积分项',
                cnTitleId:'JiFenXiang',
                cnPlaceholder:'请选择积分项',
                cnPlaceholderId:'QingXuanZeJiFenXiang',
                required: true,
                type:"Enum",
                change:(data,option={})=>this.changeEnum(data,option),
                enumList: enumList
            },
            {
                name:selectPointType=="Number"?'selectPointValue':"selectPoint",
                cnTitle:'积分值',
                cnTitleId:'JiFenZhi',
                required: selectPointType=="Number"?true:false,
                numConfig:selectPointType=="Number"?{
                    min:"1",
                    precision:0
                }:"",
                type:selectPointType,
            },
        ]
        if(needRemark){
            list.push({
                name:'remark',
                cnTitle:'积分说明',
                cnTitleId:'JiFenShuoMing',
            })
            list.push({
                name:'remarkRender',
                type:"OnlyRender",
                showTitle:true,
                title:" ",
                onlyRender: <span className={"black45"}>{Lang({id:"GenJuYongHuZhuYaoShiYongYuYanShuRuJiKe",default:"根据用户主要使用语言输入即可"})}</span>
            })
        }
        this.setState({
            moreOptions:list,
            editType:type,
            fromInitialValues:fromInitialValues
        })
    }
    /**
     * 积分管理弹窗
     * */
    openUserScore(data){
        data["customer"] = data.buyerCode +' | '+ data.name;
        this.loading(true);
        getCustomer(data.id).then(reData=>{
            const response = reData.data||[];
            const { success, valid, models } = response;
            const model = models[0]||{};
            // if (success && valid) {
            //     data["point"] = model&&model.point?model.point : '0' ;
            //     data["countryCode"] = model&&model.countryCode?model.countryCode : '' ;
            // }
            this.setFormData(model,models); // 设置表单内容
            this.setState({
                showUserScoreModal: true,
                countryList: models,
            },()=>this.loading(false));
        })
    }
    // 设置表单内容
    setFormData(model={},models=[]){
        if(this.onRefFormFormat){
            this.onRefFormFormat.setField('type');
        }// 重置 类型
        model["pointAmountText"]  = model.pointAmount? (model.pointAmount +" "+ Lang({id:"JiFen", default:""}) + " = 1 " + model.currencySymbol) :""; //  积分兑换
        const countryOptions = [
            {
                name:'pointAccount',
                cnTitle:'积分账户',
                cnTitleId:'JiFenZhangHu',
                type:'CountrySelect',
                idField:"countryCode",
                nameField:"countryName",
                list:models,
                value:model.countryCode,
                change:(data)=>this.changePoint(data),
            },
            {
                name:'type',
                cnTitle:'类型',
                cnTitleId:'LeiXing',
                cnPlaceholder:'请选择类型',
                cnPlaceholderId:'QingXuanZeLeiXing',
                required: true,
                type:"Radio",
                change:(data={})=>this.changeType(data.value),
                options:[
                    {//增加
                        value: "1",
                        cnTitleId:'ZengJia'
                    },
                    {//扣减（减分）
                        value: "-1",
                        cnTitleId:'KouJian'},
                ]
            },
        ]
        this.setState({
            fromInitialValues: model,
            countryOptions:countryOptions,
            moreOptions:[
            ],
            editType: '', //加减操作类型
            enumAddList:[ //重置内容
            ],
            enumList:[ //重置内容
            ]
        },()=>this.loading(false));
    }
    loading(flag=false){
        this.setState({
            loading: flag
        })
    }
    openUserScorePop(flag=false){
        if(!flag){ // 关闭时清空数据
            this.setState({
                showUserScoreModal: false,
                moreOptions:[
                ],
                editType: '', //加减操作类型
                enumAddList:[
                ],
                enumList:[
                ],
                fromInitialValues: {},
            })
            this.onRefFormFormat = null
        }else {
            this.setState({
                showUserScoreModal: flag
            })
        }
    }
    handleSave(data){
        const {row,} = this.props;
        const {fromInitialValues} = this.state;
        const postData = {
            buyerId:row.id,
            countryCode:fromInitialValues.countryCode, //账户所有国家
            point:fromInitialValues.selectPoint||data.selectPointValue, //当前所选 增减的积分值
            pointRuleConfigId:fromInitialValues.pointRuleConfigId,
            pointRuleConfigCode:data.pointRuleConfigCode,
            remark:data.remark
        }
        this.loading(true)
        savePointSubmit(postData).then(reData=>{
            const response = reData.data;
            this.loading(false)
            if (response.success && response.valid) {
                message.success(Lang({id: 'TiJiaoChengGong',default:'提交成功'}));
                //重置内容
                this.openUserScorePop(false);
                if(this.props.successCallBack){
                    this.props.successCallBack();
                }
            }else if (response.message){
                message.info(response.message);
            }else{
                message.info(Lang({id: 'CaoZuoShiBai',default:'操作失败'}));
            }
        })
    }
    onRefForm = (ref) =>  this.onRefFormFormat = ref;
    render(){
        const {row,} = this.props;
        const {loading,optionsVipScorePop,showUserScoreModal, fromInitialValues,countryOptions,moreOptions} = this.state;
        return (<Spin spinning={loading}>
                    {/*<Popover content={Lang({id: 'JiFenGuanLi',default:'积分管理'})}>*/}
                        {/*<IconFont type="icon-jinniancaigouzongjine"*/}
                                  {/*style={{ fontSize: "28px" }}*/}
                                  {/*onClick={()=>this.openUserScore(row)} />*/}
                    {/*</Popover>*/}
                {/*<AuthBtn icon={"ri-copper-coin-line"} tips = {Lang({id:"JiFenGuanLi",default:"积分管理"})}*/}
                         {/*auth={"Customer-Table-User-Score"}*/}
                         {/*onClick={()=>this.openUserScore(row)}/>*/}
                <AuthBtn title = {Lang({id:"JiFenGuanLi",default:"积分管理"})}
                         auth={"Customer-Table-User-Score"}
                         target={"_blank"}
                         className={"minBtnPrimary"}
                         onClick={()=>this.openUserScore(row)}/>
                {showUserScoreModal&&<ModalFormComponent showModal={showUserScoreModal}
                                                         onRef={this.onRefForm}
                                                         loading={loading}
                                                         width={520}
                                                         title={{cnTitleId: 'JiFenGuanLi',cnTitle:'积分管理'}}
                                                         options={[...optionsVipScorePop,...countryOptions,...moreOptions]}
                                                         saveFormValue={this.handleSave.bind(this)}
                                                         initialValues={fromInitialValues}
                                                         top={<div className={"popTop"} key={"userScoreTop"}>
                                                             <p className={"color-black font-bold font_16"}>{fromInitialValues.buyerCode}</p>
                                                             <p>{fromInitialValues.buyerName}</p>
                                                         </div>}
                                                         handleCancel={this.openUserScorePop.bind(this)} />}
            </Spin>
        )
    }
}

export default UserScore;
